import fetchTokenUsage from './tokenUsage';

/**
 * Update token usage and percentage.
 * @param {string} userId - The user ID for fetching token usage.
 * @param {number} tokenThreshold - The maximum token threshold.
 * @param {function} setTokenUsage - Function to update the token usage state.
 * @param {function} setUsagePercentage - Function to update the usage percentage state (optional).
 */
const updateTokenUsage = async (userId, tokenThreshold, setTokenUsage, setUsagePercentage) => {
  if (!userId) {
    console.error('User ID is required to update token usage.');
    return;
  }

  try {
    const { tokenUsage, usagePercentage } = await fetchTokenUsage(userId, tokenThreshold);
    setTokenUsage(tokenUsage); // Update the token usage
    if (setUsagePercentage) {
      setUsagePercentage(usagePercentage); // Update the usage percentage
    }
  } catch (error) {
    console.error('Failed to update token usage:', error);
  }
};

export default updateTokenUsage;
